"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelect = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var FilterSelect = /** @class */ (function (_super) {
    __extends(FilterSelect, _super);
    function FilterSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFilterChange = _this.handleFilterChange.bind(_this);
        return _this;
    }
    FilterSelect.prototype.render = function () {
        var _this = this;
        var filters = this.props.filters;
        var allFilter = filters.find(function (f) { return f.type === "all"; });
        return (react_1.default.createElement(_1.Accordion, null, function (_a) {
            var open = _a.open, onToggle = _a.onToggle;
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("h2", { className: "select-none text-grey text-base font-normal py-2 cursor-pointer", onClick: onToggle }, _this.props.label),
                open && (react_1.default.createElement("div", { style: {
                        borderColor: "#000",
                        backgroundColor: "#17282e",
                        maxHeight: 200,
                    }, className: "-mx-4 py-2 px-4 flex flex-col border-t border-b overflow-y-auto" },
                    allFilter && (react_1.default.createElement("div", { className: "py-1" },
                        react_1.default.createElement(_1.Checkbox, { label: _this.props.allLabel, onChange: function () { return _this.handleFilterChange(allFilter); }, checked: allFilter.selected, dark: true }))),
                    filters
                        .filter(function (f) { return f.type === "category"; })
                        .map(function (f) { return (react_1.default.createElement("div", { key: "category-".concat(f.id), className: "py-1" },
                        react_1.default.createElement(_1.Checkbox, { label: "All ".concat(f.label), onChange: function () { return _this.handleFilterChange(f); }, checked: f.selected, dark: true }))); }),
                    filters
                        .filter(function (f) { return f.type === "item"; })
                        .map(function (f) { return (react_1.default.createElement("div", { key: f.id, className: "py-1" },
                        react_1.default.createElement(_1.Checkbox, { label: f.label, onChange: function () { return _this.handleFilterChange(f); }, checked: f.selected, dark: true }))); })))));
        }));
    };
    FilterSelect.prototype.handleFilterChange = function (filter) {
        if (this.props.onFilterChange) {
            this.props.onFilterChange(__assign(__assign({}, filter), { selected: !filter.selected }));
        }
    };
    return FilterSelect;
}(react_1.default.Component));
exports.FilterSelect = FilterSelect;
